var $54b47fc030b7b21e$exports = {};
/* Hämta ner menyn */ window.onload = $54b47fc030b7b21e$var$init;
async function $54b47fc030b7b21e$var$init() {
    const url = "https://pizzaapi-kzs1.onrender.com/menu";
    const response = await fetch(url + "/getmenu");
    const data = await response.json();
    $54b47fc030b7b21e$var$displayMenu(data);
}
//skriv ut menyn
function $54b47fc030b7b21e$var$displayMenu(data) {
    const menuEl = document.getElementById("menu");
    data.forEach((e)=>{
        menuEl.innerHTML += `<div class="menuItem">
        <h4 class="foodname">${e.foodname}</h4>
        <p class="ingredients">${e.ingredients}</p>
        <p class="price">${e.price} kr</p> 
        </div>`;
    });
}
//visa och dölj bokningsfönstret
const $54b47fc030b7b21e$var$bookingBtnEl = document.getElementById("booking-btn");
const $54b47fc030b7b21e$var$bookingFormDivEl = document.getElementById("bookingFormDiv");
const $54b47fc030b7b21e$var$closeBtnEl = document.getElementById("closeBtn");
$54b47fc030b7b21e$var$bookingBtnEl.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$bookingFormDivEl.classList.toggle("show");
    $54b47fc030b7b21e$var$bookingFormDivEl.classList.toggle("hidden");
    $54b47fc030b7b21e$var$bookingBtnEl.classList.toggle("active");
});
$54b47fc030b7b21e$var$closeBtnEl.addEventListener("click", ()=>{
    $54b47fc030b7b21e$var$bookingFormDivEl.classList.toggle("show");
    $54b47fc030b7b21e$var$bookingFormDivEl.classList.toggle("hidden");
    $54b47fc030b7b21e$var$bookingBtnEl.classList.toggle("active");
});


//# sourceMappingURL=index.aae015f8.js.map
